import { Action, createReducer, on } from '@ngrx/store';
import { remove } from 'lodash';

import { Label } from '../../classes/label';
import { PremiitError } from '../../utils/premiit-error';
import * as labelsActions from '../actions/labels.actions';

export interface LabelState {
  data: Label[];
  selected: Label;
  loading: boolean;
  color: string;
  error: PremiitError;
}

const labelInitState: LabelState = {
  data: [],
  selected: null,
  loading: false,
  color: null,
  error: null
};

const _labelReducer = createReducer(
  labelInitState,
  on(labelsActions.getLabelsAction, (state: LabelState) => ({ ...state, loading: true })),
  on(labelsActions.getLabelsSuccessAction, (state: LabelState, { labels }) => ({
    ...state,
    data: [...labels],
    loading: false,
    error: null
  })),
  on(labelsActions.getLabelsErrorAction, (state: LabelState, { error }) => ({
    ...state,
    loading: false,
    error
  })),
  on(labelsActions.selectLabel, (state: LabelState, { label }) => ({
    ...state,
    selected: { ...label }
  })),
  on(labelsActions.unSelectLabel, (state: LabelState) => ({
    ...state,
    selected: null
  })),
  on(labelsActions.setLabelColor, (state: LabelState, { color }) => ({
    ...state,
    color
  })),
  on(labelsActions.createLabelAction, (state: LabelState) => ({
    ...state,
    loading: true
  })),
  on(labelsActions.createLabelSuccessAction, (state: LabelState, { label }) => {
    const data: Label[] = [...state.data, label];
    return {
      ...state,
      data,
      loading: false,
      error: null
    };
  }),
  on(labelsActions.createLabelErrorAction, (state: LabelState, { error }) => ({
    ...state,
    loading: false,
    error
  })),
  on(labelsActions.updateLabelAction, (state: LabelState) => ({ ...state, loading: true })),
  on(labelsActions.updateLabelSuccessAction, (state: LabelState, { label }) => ({
    ...state,
    data: state.data.map((l: Label) => (l.id === label.id ? { ...label } : l)),
    selected: null,
    color: null,
    loading: false
  })),
  on(labelsActions.updateLabelErrorAction, (state: LabelState, { error }) => ({
    ...state,
    loading: false,
    error
  })),
  on(labelsActions.deleteLabelAction, (state: LabelState) => ({
    ...state,
    loading: true,
    error: null
  })),
  on(labelsActions.deleteLabelSuccessAction, (state: LabelState, { label }) => {
    const data = [...state.data];
    remove(data, (item: Label) => label.id === item.id);
    return {
      ...state,
      data,
      loading: false,
      error: null,
      selected: null,
      color: null
    };
  }),
  on(labelsActions.deleteLabelError, (state: LabelState, { error }) => ({
    ...state,
    loading: false,
    error
  }))
);

export function LabelsReducer(state: LabelState, action: Action): LabelState {
  return _labelReducer(state, action);
}
